/*
 * @Date: 2022-07-04 17:19:47
 * @LastEditors: chuhongguang
 * @desc: 页面Html框架（头部导航栏）
 */
export default {
  home: "公司概览",

  about: "关于我们",
  companyProfile: "公司简介", // 关于我们/公司简介
  management: "管理层成员", // 关于我们/管理层成员
  corporateGovernance: "公司治理", // 关于我们/公司治理
  irNetwork: "投资者关系联络", // 关于我们/投资者关系联络

  disclosure: "信息披露",
  circulars: "公告与通函", // 信息披露/公告与通函
  stockPrice: "股价信息", // 信息披露/股价信息

  finance: "财务信息",
  quarter: "中期报告", // 财务信息/中期报告
  year: "年度报告", // 财务信息/年度报告

  esg: "ESG 报告"
}